import { toast } from "react-toastify";
import { sendOTPAction } from "../../../../Auth/Register/API/Action";

export const handleResendOTP = async (payload) => {
  const { error, message } = await sendOTPAction(payload);
  if (!error) {
    toast.success(message || "OTP sent successfully");
    return { success: true, message };
  } else {
    toast.error(message || "Failed to resend OTP");
    return { success: false, message };
  }
};

export const getNameInitials = (name = "") => {
  const parts = name.trim().split(/\s+/).filter(Boolean);

  if (!parts.length) return "?";
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();

  return `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(0)}`.toUpperCase();
};
